import { render, staticRenderFns } from "./OmsetRecap.vue?vue&type=template&id=4e517014&scoped=true"
import script from "./OmsetRecap.vue?vue&type=script&lang=js"
export * from "./OmsetRecap.vue?vue&type=script&lang=js"
import style0 from "./OmsetRecap.vue?vue&type=style&index=0&id=4e517014&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e517014",
  null
  
)

export default component.exports